import en from './en/index';
import fr from './fr/index';

export default {
  en,
  fr,
};
